import { Schema } from '../schemas'
import { AppState } from '../store'

export const createableSchemasSelector = (state: AppState): Schema[] => state?.createableSchemas ?? []
